let baseUrl = process.env.COS_URL_PREFIX
export default {
  baseUrl
}